export default __webpack_public_path__ + "static/buy-with-prime-89b2630b27fa55285ac292b48b8a2b48.svg";